"use client";

import { useEffect, useState } from "react";
import { captureUtms, type Utms } from "@/lib/utm";

// ============================================================================
// Hook UTM — capture les paramètres de campagne de l'URL au montage (merge +
// persistance en sessionStorage via `captureUtms`, idempotent) et les expose.
// Sert notamment à préremplir la réservation cal.com. L'envoi webhook et
// l'analytics relisent le stockage directement (pas besoin de ce hook).
// ============================================================================

export function useUtms(): Utms {
  const [utms, setUtms] = useState<Utms>({});
  useEffect(() => {
    setUtms(captureUtms());
  }, []);
  return utms;
}
